
	import Vue from "vue"
	import Component from "vue-class-component"
	import Page from "custom/Page.vue"
	import ContentHeader from "custom/ContentHeader.vue"

	import { Agreement, CoverageDefault, CoverageOption, EmployeeContributionType, ProductFrameworkType, ScaleType, SurvivorsPensionType } from "store/company/types"
	import { companyModule } from "store/modules"
	import Secured from "utils/security/Secured"
	import { session } from "api/index"

	enum AgreementScalePercentage {
		TEN = 10,
		HUNDRED = 100
	}

	@Secured(session)
	@Component({
		components: {
			Page,
			ContentHeader
		}
	})
	export default class PensionScheme extends Vue {
		@companyModule.Getter agreement?: Agreement
		readonly baseTranslationKey = "pensionScheme"
		readonly scaleType = ScaleType
		readonly survivorsPensionType = SurvivorsPensionType
		readonly EmployeeContributionType = EmployeeContributionType
		readonly AgreementScalePercentage = AgreementScalePercentage

		formatDecimalNumber(percentage: number): string {
			return percentage.toFixed(this.maximumDecimalPlaces(percentage) + 1).replace(".", ",").slice(0, -1)
		}

		maximumDecimalPlaces(percentage: number): number {
			if (!this.isWTP) {
				if (percentage.toString().includes(".")) {
					return Math.min(percentage.toString().split(".")[1].length, 3)
				}
				return 3
			}
			return 2
		}

		translateTransitionalName(transitional: any): string {
			switch (transitional) {
				case 2: return "2,00%"
				case 2.5: return "2,50%"
				case 3: return "3,00%"
				case 4: return "4,00%"
				case 38: return "Staffel 38r"
				default: return ""
			}
		}

		get scaleDecimals(): number {
			return this.agreement?.scale?.type === ScaleType.AGE_DEPENDENT ? 0 : 1
		}

		get productName(): string {
			if (!this.isWTP) {
				return "Pré WTP"
			} else if (this.isWTP && this.agreement?.scale?.type === ScaleType.TRANSITIONAL_ARRANGEMENT) {
				return "WTP met overgangsregime"
			} else {
				return "WTP"
			}
		}

		get agreementScalePercentage(): number {
			const rate = this.agreement?.scale?.utilizationRate || 0
			return rate / 10
		}

		get activeCoverageOptions(): Array<CoverageOption> {
			return this.agreement?.insurance?.anwGap?.coverageOptions || []
		}

		get coverageDefault(): CoverageDefault | undefined {
			return this.agreement?.insurance.anwGap?.coverageDefault
		}

		get productType(): ProductFrameworkType {
			return this.agreement?.productType ?? ProductFrameworkType.WNP
		}

		get isWTP(): boolean {
			return this.productType === ProductFrameworkType.WTP
		}
	}
